export const SYSTEM = 'SYSTEM';
export const AGENT = 'AGENT';